import * as React from 'react'

import { Image, Video } from 'lucide-react'

import * as Icons from '~/client/src/shared/components/Icons'

import FileType from '../../enums/FileType'
import {
  imageExtensions,
  msExcelExtensions,
  msPowerPointExtensions,
  msWordExtensions,
  pdfExtension,
  videoExtensions,
} from '../../stores/domain/FileUploading.store'

export function getAttachmentText(fileName: string): string {
  switch (getAttachmentFileType(fileName)) {
    case FileType.Word:
      return 'MS Word'
    case FileType.Excel:
      return 'MS Excel'
    case FileType.PowerPoint:
      return 'MS PowerPoint'
    case FileType.Pdf:
      return 'PDF'
    case FileType.Image:
      return 'Image'
    case FileType.Video:
      return 'Video'
    default:
      return null
  }
}

export function getAttachmentFileIcon(
  fileName: string,
  className: string = 'tw:size-9 no-flex mr10',
  separator: string = '.',
): JSX.Element {
  switch (getAttachmentFileType(fileName, separator)) {
    case FileType.Word:
      return <Icons.WordApp className={className} />
    case FileType.Excel:
      return <Icons.ExcelApp className={className} />
    case FileType.PowerPoint:
      return <Icons.PPTXApp className={className} />
    case FileType.Pdf:
      return <Icons.PDFApp className={className} />
    case FileType.Image:
      return <Image className={className} />
    case FileType.Video:
      return <Video className={className} />
    default:
      return <Icons.File className={`${className} icon-dark-grey`} />
  }
}

function getAttachmentExtension(
  fileName: string,
  splitChar: string = '.',
): string {
  return fileName.split(splitChar)?.pop()?.toLowerCase()
}

export function getAttachmentFileType(
  fileName: string,
  splitChar: string = '.',
  shouldShowImageExtension: boolean = false,
): FileType | string {
  const ext = getAttachmentExtension(fileName, splitChar)
  switch (true) {
    case imageExtensions.includes(ext):
      if (shouldShowImageExtension) {
        return ext
      }
      return FileType.Image
    case pdfExtension === ext:
      return FileType.Pdf
    case videoExtensions.includes(ext):
      return FileType.Video
    case msWordExtensions.includes(ext):
      return FileType.Word
    case msExcelExtensions.includes(ext):
      return FileType.Excel
    case msPowerPointExtensions.includes(ext):
      return FileType.PowerPoint
    default:
      return FileType.OtherFile
  }
}
